export default __webpack_public_path__ + "img/header.55358392.webp";